import MKTypography from "components/MKTypography";
import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { StyledPageContainer } from "styles/components/PageContainer/index.styles";
// Seo data
import couplesTherapySeo from "./data/seoData/couplesTherapySeo.data.json";
import individualTherapySeo from "./data/seoData/individualTherapySeo.data.json";
import lgbtqiaTherapySeo from "./data/seoData/lgbtqiaTherapySeo.data.json";
import veteransTherapySeo from "./data/seoData/veteransTherapySeo.data.json";
// Schema data
import couplesTherapySchema from "./data/schemaData/couplesTherapySchema.data.json";
import individualTherapySchema from "./data/schemaData/individualTherapySchema.data.json";
import lgbtqiaTherapySchema from "./data/schemaData/lgbtqiaTherapySchema.data.json";
import veteransTherapySchema from "./data/schemaData/veteransTherapySchema.data.json";
import SEO from "components/CBSEO";
import SchemaComponent from "components/CBSchema";
import { constructSchemaData } from "utils/helpers/constructSchemaData";
import individualTherapyContent from "./data/pageContentData/individualTherapyContent.data.json";
import useDynamicPageRenderer from "utils/hooks/useDynamicPageRenderer";
import DynamicHero from "components/DynamicHero";
import TextBlock from "components/TextBlock";
import ThreeColumnSection from "styles/components/threeColumnSection";
import Testimonials from "components/Testimonials";
import HowItWorks from "components/CBHowItWorks";
import { TwoColumnSection } from "styles/components/twoColumnSection";
import StartYourJourney from "pages/TherapyHub/components/startYourJourney";
import { ImageContainer } from "styles/components/imageContainer";
import ResourcesSlider from "pages/TherapyHub/components/resourcesSlider";
import FAQContent from "components/CBFAQ";
import InsuranceSection from "components/InsuranceSection";
import CBDivider from "components/CBDivider";
import GetStartedToday from "pages/TherapyHub/components/GetStartedToday";
import FourColumnSection from "styles/components/fourColumnSection";
import couplesTherapyContent from "./data/pageContentData/couplesTherapyContent.data.json";
import lgbtqiaTherapyContent from "./data/pageContentData/lgbtqiaTherapyContent.data.json";
import veteransTherapyContent from "./data/pageContentData/veteransTherapyContent.data.json";
import TherapyOptions from "components/TherapyOptions";

// Todo -
// 1. contentMap
// 4. componentMap
// 5. useDynamicPageRenderer

const pageContentMap = {
  "individual-therapy": individualTherapyContent,
  "couples-therapy": couplesTherapyContent,
  "lgbtqia": lgbtqiaTherapyContent,
  "veterans": veteransTherapyContent,
};

const seoMap = {
  "couples-therapy": couplesTherapySeo,
  "individual-therapy": individualTherapySeo,
  "lgbtqia": lgbtqiaTherapySeo,
  "veterans": veteransTherapySeo,
};

const schemaMap = {
  "couples-therapy": couplesTherapySchema,
  "individual-therapy": individualTherapySchema,
  "lgbtqia": lgbtqiaTherapySchema,
  "veterans": veteransTherapySchema,
};

const componentMap = {
  "DynamicHero": DynamicHero,
  "TextBlock": TextBlock,
  "ThreeColumnSection": ThreeColumnSection,
  "Testimonials": Testimonials,
  "HowItWorks": HowItWorks,
  "TwoColumnSection": TwoColumnSection,
  "StartYourJourney": StartYourJourney,
  "ImageContainer": ImageContainer,
  "ResourcesSlider": ResourcesSlider,
  "Faq": FAQContent,
  "InsuranceSection": InsuranceSection,
  "Divider": CBDivider,
  "GetStartedToday": GetStartedToday,
  "FourColumnSection": FourColumnSection,
  "TherapyOptions": TherapyOptions,
};

const SPREAD_PROPS_COMPONENTS = [
  "DynamicHero",
  "TextBlock",
  "ThreeColumnSection",
  "Testimonials",
  "HowItWorks",
  "TwoColumnSection",
  "FourColumnSection",
];

const TherapyType = () => {
  const location = useLocation();
  const therapyType = location.pathname.split("/")[2];
  const content = pageContentMap[therapyType];
  const seoData = seoMap[therapyType];
  const schemaDataRaw = schemaMap[therapyType];
  const schemaData = schemaDataRaw.url ? constructSchemaData(schemaDataRaw.url, schemaDataRaw.breadcrumbs) : [];

  const renderedComponents = useDynamicPageRenderer(content, componentMap, SPREAD_PROPS_COMPONENTS);

  return (
    <StyledPageContainer id={`${therapyType}-therapy-type-page-container`}>
      <SEO title={seoData.title} description={seoData.description} canonicalUrl={seoData.canonicalUrl} />
      <SchemaComponent schemas={schemaData} />

      {content ? (
        renderedComponents
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <MKTypography variant="h1">Therapy Type - {therapyType}</MKTypography>
          <Link to={`/online-therapy/${therapyType}/colorado`}>Colorado - {therapyType}</Link>
          <Link to={`/online-therapy/${therapyType}/ohio`}>Ohio - {therapyType}</Link>
          <Link to={`/online-therapy/${therapyType}/florida`}>Florida - {therapyType}</Link>
        </div>
      )}
    </StyledPageContainer>
  );
};

export default TherapyType;
